/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountReviewAction {
    APPROVE = 'APPROVE',
    DECLINE = 'DECLINE',
    REVOKE = 'REVOKE',
}
